import { Table, TableCell, TableRow, withStyles } from "@material-ui/core";

export const StyledTable = withStyles((theme) => ({
  root: {
    minWidth: 650,
  },
}))(Table);

export const StyledTableRow = withStyles((theme) => ({
  root: {
    border: "none",
    borderBottom: "1px solid #EEEEEE",
  },
}))(TableRow);

export const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: "#212121",
    fontSize: 12,
    fontWeight: "bold",
    alignItems: "center",
    border: "none",
    padding: "16px 8px",
  },
  body: {
    fontSize: 12,
    border: "none",
    padding: 8,
  },
}))(TableCell);

export const StyledTableCellStruct = withStyles((theme) => ({
  body: {
    fontSize: 11,
    padding: "13px 16px !important",
  },
}))(TableCell);

export const StyledTableCellBodyBold = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: "#212121",
    fontSize: 12,
    fontWeight: "bold",
    alignItems: "center",
    border: "none",
    padding: "16px 8px",
  },
  body: {
    fontSize: 12,
    border: "none",
    padding: 8,
    fontWeight: "bold",
  },
}))(TableCell);

export const StyledTableCellBodyBoldStruct = withStyles((theme) => ({
  body: {
    fontSize: 11,
    padding: "13px 16px !important",
    fontWeight: "bold",
  },
}))(TableCell);

export const IZYTable = withStyles((theme) => ({
  root: {
    minWidth: 650,
  },
}))(Table);

export const IZYTableRow = withStyles((theme) => ({
  root: {
    border: "none",
    borderBottom: "1px solid #EEEEEE",
  },
}))(TableRow);

export const IZYTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#EEEEEE",
    color: "#212121",
    fontSize: 10,
    fontWeight: "bold",
    alignItems: "left",
    border: "none",
    padding: "13px 12px",
  },
  body: {
    fontSize: 11,
    border: "none",
    padding: "13px 12px",
  },
}))(TableCell);
